import { unref as _unref, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";

import { fetchApi } from '/Users/ytx/ytx/projects/jxpj/web/jxpj-client/src/server/auto-import.js';
import { ref, reactive, onMounted } from 'vue';
const _hoisted_1 = {
  class: "mg-ui-my-org-list-view-wrapper"
};
export default {
  __name: 'my-org-list-view',
  setup(__props, {
    expose: __expose
  }) {
    const {
      runAsync: getMyOrgListApi
    } = fetchApi('org.getMyOrgList');
    const orgList = ref([]);
    const selectRow = ref();
    const loadMyOrgList = async () => {
      const {
        error,
        rows
      } = await getMyOrgListApi({});
      if (error) return;
      orgList.value = rows;
    };
    const gridOptions = reactive({
      border: true,
      headerAlign: 'center',
      align: 'left',
      rowConfig: {
        keyField: 'id',
        isHover: true,
        isCurrent: true
      },
      columns: [{
        type: 'seq',
        field: '序号',
        width: 70,
        fixed: 'left'
      }, {
        field: 'name',
        title: '单位名称',
        width: 240
      }, {
        field: 'contactPer',
        title: '联系人',
        width: 120
      }, {
        field: 'contactTel',
        title: '联系电话',
        width: 120
      }]
    });
    const handleSelectRowChanged = ({
      row
    }) => {
      selectRow.value = row;
    };
    onMounted(() => {
      loadMyOrgList();
    });
    __expose({
      confirmListener() {
        return Promise.resolve(selectRow.value);
      }
    });
    return (_ctx, _cache) => {
      const _component_vxe_grid = _resolveComponent("vxe-grid");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_vxe_grid, _mergeProps(_unref(gridOptions), {
        data: _unref(orgList),
        height: "100%",
        onCurrentRowChange: handleSelectRowChanged
      }), null, 16, ["data"])]);
    };
  }
};